import { appleProvider, firebaseApp, googleProvider } from "../../components/firebase";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";

export const SET_MAPPINGS = "SET_MAPPINGS";

export const setMappingsList = (mappings = []) => {
  const names = {};
  mappings.map(({ org_id, org_name, groups = [] }) => {
    names[org_id] = org_name;
    groups.map(({ group_id, group_name }) => {
      const key = `${org_id}_${group_id}`;
      names[key] = `${org_name} - ${group_name}`;
    });
  });
  return {
    type: SET_MAPPINGS,
    mappings,
    mappingNames: names,
  };
};

const requestLogin = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

export const receiveLogin = (user) => {
  return {
    type: LOGIN_SUCCESS,
    user,
  };
};

const loginError = () => {
  return {
    type: LOGIN_FAILURE,
  };
};

const requestLogout = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};

const receiveLogout = () => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

const logoutError = () => {
  return {
    type: LOGOUT_FAILURE,
  };
};

const verifyRequest = () => {
  return {
    type: VERIFY_REQUEST,
  };
};

const verifySuccess = () => {
  return {
    type: VERIFY_SUCCESS,
  };
};

export const loginUserEmailPass = (successCB, email, password, errorCB) => (dispatch) => {
  processLogin(dispatch, () => emailPassSigIn(email, password), successCB, errorCB);
};

export const signupUserEmailPass = (successCB, email, password, errorCB) => (dispatch) => {
  processLogin(dispatch, () => emailPassSigUp(email, password), successCB, errorCB);
};

export const loginUserGoogle = (successCB, errorCB) => (dispatch) => {
  processLogin(dispatch, googleSignIn, successCB, errorCB);
};

export const loginUserApple = (successCB, errorCB) => (dispatch) => {
  processLogin(dispatch, appleSignIn, successCB, errorCB);
};

export const processLogin = (dispatch, authCB, successCB, errorCB) => {
  try {
    dispatch(requestLogin());
    authCB()
      .then((user) => {
        if (successCB != undefined) successCB(user);
      })
      .catch((error) => {
        dispatch(loginError());
        if (errorCB != undefined) errorCB(error);
      });
  } catch (error) {
    if (errorCB != undefined) errorCB(error);
  }
};

export const logoutUser = () => (dispatch) => {
  dispatch(requestLogout());
  firebaseApp
    .auth()
    .signOut()
    .then(() => {
      dispatch(receiveLogout());
    })
    .catch((error) => {
      dispatch(logoutError());
    });
};

export const verifyAuth = () => (dispatch) => {
  dispatch(verifyRequest());
  firebaseApp.auth().onAuthStateChanged((user) => {
    if (user !== null) {
      dispatch(receiveLogin(user));
    }
    dispatch(verifySuccess());
  });
};

export const emailPassSigIn = async (email, password) => {
  return firebaseApp.auth().signInWithEmailAndPassword(email, password);
};

export const emailPassSigUp = async (email, password) => {
  return firebaseApp.auth().createUserWithEmailAndPassword(email, password);
};

export const googleSignIn = async () => {
  return firebaseApp.auth().signInWithPopup(googleProvider);
};

export const appleSignIn = async () => {
  return firebaseApp.auth().signInWithPopup(appleProvider);
};
